export const navigation = [
    {name: "Home", href: "joglekarkul"},
    {name: "Kulavruksh", href: "kulavruksh"},
    {name: "Information", href: "info"},
    {name: "Dashboard", href: "dashboard"},
    // {name: "Coming soon", href: "#"},
]

export const footerNav = {
    social: [
        {
            name: "Facebook",
            href: "https://www.facebook.com/groups/joglekarkul",
            icon: "landing/facebook.png"
        },
        {
            name: "Instagram",
            href: "/",
            icon: "landing/insta.png"
        },
        {
            name: "X",
            href: "/",
            icon: "landing/tweeter.png"
        },
        {
            name: "YouTube",
            href: "http://www.youtube.com/@Joglekarkul",
            icon: "landing/youtube.png"
        },
    ],
}
